import { render } from "./role-list-modal.vue?vue&type=template&id=1afbd424"
import script from "./role-list-modal.vue?vue&type=script&lang=js"
export * from "./role-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__